import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function FlashcardChemTopics() {
  return (
    <>

      <AllSubjectTopics subject="chemistry" type="flashcard" />


    </>
  );
}

export default FlashcardChemTopics;